// @ts-check
/**
 * @typedef {Object} ffInputBlockSubmitCustomProperties
 * @property {boolean} ffHasErrors => true if the input passed all validations
 *
 * @typedef {ffInputBlockSubmitCustomProperties & HTMLElement} FfInputBlockSubmit
 */

if (!customElements.get("ff-input-block-submit")) {
  class FfInputBlockSubmit extends HTMLElement {
    constructor() {
      super();

      /**
       * @type {HTMLInputElement}
       */
      //@ts-ignore
      this.ffInput = this.querySelector("[data-ff-input-block-submit]");

      const {
        ffErrorSelector,
        ffShowErrorClass,
        ffSubmitSelector,
        ffErrorElOutside,
      } = this.dataset;

      /**
       * @type {HTMLButtonElement}
       */
      //@ts-ignore
      this.ffSubmitEl = document.querySelector(ffSubmitSelector || "");

      /**
       * @type {HTMLElement}
       */
      //@ts-ignore
      this.ffErrorEl =
        ffErrorElOutside == "true"
          ? document.querySelector(ffErrorSelector || "")
          : this.querySelector(ffErrorSelector || "");

      /**
       * @type {String}
       */
      //@ts-ignore
      this.ffShowErrorClass = ffShowErrorClass;

      this.init();
    }

    init() {
      this.ffInput.addEventListener("input", this.inputHandler);
      this.inputHandler();
    }

    inputHandler = () => {
      const { checked, dataset, value } = this.ffInput;
      const {
        ffErrorWidthMatch,
        ffErrorEmptyMsg,
        ffErrorFormatMsg,
        ffErrorUncheckedMsg,
        ffErrorLuhnMsg,
        ffValidFormat,
      } = dataset;

      let errorMsg = "";

      this.ffSubmitEl.removeEventListener("click", this.submitHandlerBlock);
      this.ffErrorEl.classList.remove(this.ffShowErrorClass);
      if (ffErrorWidthMatch) {
        this.ffErrorEl.style.width = `${this.ffInput.clientWidth}px`;
      }

      if (ffErrorLuhnMsg) {
        if (!this.ffLuhnValidation(value)) {
          errorMsg = ffErrorLuhnMsg;
        }
      }

      if (ffErrorUncheckedMsg) {
        if (!checked) {
          errorMsg = ffErrorUncheckedMsg;
        }
      }

      if (ffErrorFormatMsg && ffValidFormat) {
        const validation = new RegExp(ffValidFormat);
        if (!validation.test(value)) {
          errorMsg = ffErrorFormatMsg;
        }
      }

      if (value.length == 0) {
        if (ffErrorEmptyMsg) {
          errorMsg = ffErrorEmptyMsg;
        }
        this.dataset.ffInputFilled = "false";
      } else {
        this.dataset.ffInputFilled = "true";
      }

      /**
       * @type {string[]} The submit button can be blocked by many inputs, so they use dataset to know whose are blocking the submit
       */
      let blockedBy = JSON.parse(this.ffSubmitEl.dataset.blockedBy || "[]");
      this.ffValue = value;
      if (errorMsg) {
        this.ffHasErrors = true;
        this.ffErrorEl.innerHTML = errorMsg;
        blockedBy.push(this.ffInput.name);
        this.ffSubmitEl.dataset.blockedBy = JSON.stringify(blockedBy);
        this.ffSubmitEl.addEventListener("click", this.submitHandlerBlock);
      } else {
        this.ffHasErrors = false;
        blockedBy = blockedBy.filter((name) => name != this.ffInput.name);
        this.ffSubmitEl.dataset.blockedBy = JSON.stringify(blockedBy);
      }
    };

    submitHandlerBlock = (e) => {
      this.ffErrorEl.classList.add(this.ffShowErrorClass);
      e.preventDefault();
    };

    /**
     *
     * @param {string} cc
     * @returns
     */
    ffLuhnValidation(cc) {
      var sumaPar = 0;
      var sumaImpar = 0;
      for (var i = 0; i < cc.length; i++) {
        if (i % 2 == 0) {
          if (parseInt(cc.substring(i, i + 1)) * 2 > 9)
            sumaImpar += parseInt(cc.substring(i, i + 1)) * 2 - 9;
          else sumaImpar += parseInt(cc.substring(i, i + 1)) * 2;
        } else sumaPar += parseInt(cc.substring(i, i + 1));
      }
      var suma = sumaPar + sumaImpar;
      var MOD = suma % 10;
      if (MOD == 0) return true;
      else return false;
    }
  }

  customElements.define("ff-input-block-submit", FfInputBlockSubmit);
}
